<template>
	<div class="group-wrapper-subsection">
		<!-- <img class="line-2" alt="Line" src="/img/line-3.svg" /> -->
		<!-- <img class="line-3" alt="Line" src="/img/line-4.svg" /> -->
		<div @mouseover="indexmouseover(0)" @mouseleave="resetIndex" :class="index == 0 ? 'select_dev group-3s' : 'group-3'">
		  <div :class="index == 0 ? 'select_box' : 'overlap-group-3'">
		    <img alt="Vector" :src="index == 0 ? '/img/Union.png' : '/img/Union (1).png'" style="text-align: center;" :class="index == 0 ? 'select_img' : ''"/>
		    <div style="text-align: center;" :class="index == 0 ? 'titlesbais' : 'titlesbai'">
		      {{ index == 0 ? '朗乾愿景' : '朗乾愿景' }}
		    </div>
		  </div>
		  <div :class="index == 0 ? 'text_sbais' : 'text_sbai'">
		    {{ index == 0 ? '朗耀新程，乾行致远' : 'Langqian philosophy' }}
		  </div>
		</div>

		<img class="line-2" alt="Line" src="/img/line-3.svg" />

		<div  @mouseover="indexmouseover(1)" @mouseleave="resetIndex" :class="index == 1?'select_dev group-3s':'group-3'">
			<div  :class="index == 1?'select_box':'overlap-group-3'">
				<img alt="Vector"  :src="index == 1?'/img/Frames.png':'/img/vector.svg'" style="text-align: center;" :class="index == 1?'select_img':''"/>
				<div style="text-align: center;" :class="index == 1?'titlesbais':'titlesbai'">{{index == 1?'朗乾理念':'朗乾理念'}}</div>
				
			</div>
			<div :class="index == 1?'text_sbais':'text_sbai'">{{index == 1?'专业、创新、协作、共赢':'Langqian philosophy'}}</div>
		</div>
		<img class="line-2" alt="Line" src="/img/line-3.svg" />
		<div  @mouseover="indexmouseover(2)" @mouseleave="resetIndex" :class="index == 2?'select_dev group-3s':'group-3'">
			<div  :class="index == 2?'select_box':'overlap-group-3'">
				<img alt="Vector"  :src="index == 2?'/img/Framess.png':'/img/union-1.svg'" style="text-align: center;" :class="index == 2?'select_img':''"/>
				<div style="text-align: center;" :class="index == 2?'titlesbais':'titlesbai'">{{index == 2?'朗乾文化':'朗乾文化'}}</div>
				
			</div>
			<div :class="index == 2?'text_sbais':'text_sbai'">{{index == 2?'以勤勉的精神与精湛的专业弘扬真理、正义与公道。':'Langqian culture'}}</div>
		</div>
		
		
		<img class="line-2" alt="Line" src="/img/line-3.svg" />
		
		<div  @mouseover="indexmouseover(3)" @mouseleave="resetIndex" :class="index == 3?'select_dev group-3s':'group-3'">
			<div  :class="index == 3?'select_box':'overlap-group-3'">
				<img alt="Vector"  :src="index == 3?'/img/Union (2).png':'/img/union-2.svg'" style="text-align: center;" :class="index == 3?'select_img':''"/>
				<div style="text-align: center;" :class="index == 3?'titlesbais':'titlesbai'">{{index == 3?'朗乾成就':'朗乾成就'}}</div>
				
			</div>
			<div :class="index == 3?'text_sbais':'text_sbai'">{{index == 3?'初心如磐，秉持正义，与法同行，卓越数载':'Langqian Achievements'}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "CompanyIntro",
		data() {
			return{
				index: -10
			}
		},
		methods:{
			indexmouseover(e){
				this.index = e
			},
			 resetIndex() {
			      this.index = -10; // 鼠标移出时重置
			    }
		}
	};
</script>

<style>
	.titlesbai,
	.titlesbais {
	  position: relative;
	  z-index: 99999;
	  padding-right: 60px; /* 可根据你排版情况酌情增加 */
	}

	.select_box{
		display: flex;align-items: center;margin-left: 15px;
	}
	.select_img{
		text-align: center;height: 33px;width: 31.21px;
		margin-right: 15px;
	}
	/* .select_dev{
		background-color: #7a3529;color: #fff !important;
	} */
	.select_dev {
	  background-color: #7a3529;
	  color: #fff !important;
	  position: relative;  /* ✅ 关键：为伪元素定位的参考 */
	  z-index: 1;           /* 让整体有层级 */
	  overflow: hidden;     /* 防止伪元素跑出容器 */
	}
	
	/* ✅ 使用 z-index -1 保证在最底层 */
	.select_dev::before,
	.select_dev::after {
	  content: '';
	  position: absolute;
	  top: 0;
	  width: 30px;
	  height: 100%;
	  z-index: -1; /* ✅ 关键：放在背景下面 */
	}
	
	.select_dev::before {
	  right: 30px;
	  background-color: #7a3f35;
	}
	
	.select_dev::after {
	  right: 0;
	  background-color: #7a4a41;
	}

	.titlesbais {
		/* width: 100%; */
		padding: 20px 0;
		/* color: #000000cc; */
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 20px;
		font-weight: 500;
		letter-spacing: 3.20px;
		line-height: normal;
		/* flex: 1; */
	}
	.titlesbai {
		width: 100%;
		padding: 20px 0 0 0;
		/* color: #000000cc; */
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 20px;
		font-weight: 500;
		/* letter-spacing: 3.20px; */
		line-height: normal;
		/* flex: 1; */
	}

	.text_sbai {
		/* color: #000000b2; */
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 12px;
		font-weight: 500;
		letter-spacing: 2.38px;
		line-height: normal;
		text-align: center;
	}
	
	.text_sbais {
		/* color: #000000b2; */
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 16px;
		font-weight: 500;
		letter-spacing: 2.38px;
		line-height: normal;
		margin-left: 15px;
		z-index: 999;
		/* text-align: center; */
	}
	

	.group-wrapper-subsection {
		background-color: #ffffff;
		height: 180px;
		/* left: 40px; */
		
		top: 631px;
		width: 1107px;
		display: flex;
		position: absolute;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 99;
		align-items: center;
	}

	.group-wrapper-subsection .line-2 {
		height: 92px;
		left: 604px;
		object-fit: cover;
		
		top: 44px;
		width: 1px;
	}

	.group-wrapper-subsection .line-3 {
		height: 92px;
		left: 906px;
		object-fit: cover;
		
		top: 44px;
		width: 1px;
	}

	.group-wrapper-subsection .group-3 {
		/* background-color: #7a3529; */
		height: 180px;
		left: 0;
		position: relative;
		top: -16px;
		width: 25%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
	}
	
	.group-wrapper-subsection .group-3s {
		/* background-color: #7a3529; */
		height: 180px;
		left: 0;
		position: relative;
		top: 0px;
		width: 25%;
		padding-top:10px;
		/* display: flex; */
/* 		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center; */
	}

	.group-wrapper-subsection .overlap-group-3 {
		/* height: 200px; */
		/* width: 40%; */
		/* margin-left: 30px; */
		position: relative;
		margin-top: 30px;
		/* margin-top: 40px; */
	}

	.group-wrapper-subsection .rectangle-4 {
		background-color: #7a3f35;
		height: 200px;
		right: 30px;
		position: absolute;
		top: 0;
		width: 30px;
		z-index: 1;
		pointer-events: none;
	}
	.group-wrapper-subsection .rectangle-5 {
		background-color: #7a4a41;
		position: absolute;
		height: 200px;
		right: 0px;
		pointer-events: none;
		top: 0;
		z-index: 1;
		width: 30px;
	}

	.group-wrapper-subsection .group-4 {
		height: 88px;
		left: 0;
		
		top: 20px;
		width: 166px;
	}
	

	.group-wrapper-subsection .text-wrapper-19 {
		/* color: var(--q-pd-79g); */
		font-family: "PingFang SC-Regular", Helvetica;
		font-size: 18px;
		font-weight: 400;
		left: 30px;
		letter-spacing: 0;
		line-height: 37px;
		
		top: 51px;
		white-space: nowrap;
		
	}

	.group-wrapper-subsection .text-wrapper-20 {
		/* color: #ffffff; */
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 20px;
		font-weight: 500;
		left: 70px;
		letter-spacing: 0;
		line-height: normal;
		
		top: 3px;
	}

	.group-wrapper-subsection .frame {
		background-image: url(/img/union.svg);
		background-size: 100% 100%;
		height: 33px;
		left: 30px;
		
		top: 0;
		width: 32px;
	}

	

	.group-wrapper-subsection .group-5 {
		height: 200px;
		width: 24.99%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		position: relative;
	}

	.group-wrapper-subsection .overlap-3 {
		height: 47px;
		left: 0;
		
		top: 50px;
		width: 280px;
	}

	.group-wrapper-subsection .text-wrapper-21 {
		color: #000000cc;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 20px;
		font-weight: 500;
		left: 44px;
		letter-spacing: 3.20px;
		line-height: normal;
		
		top: 0;
	}

	.group-wrapper-subsection .text-wrapper-22 {
		color: #000000b2;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 14px;
		font-weight: 500;
		left: 0;
		letter-spacing: 2.38px;
		line-height: normal;
		
		text-align: center;
		top: 27px;
	}

	.group-wrapper-subsection .vector-wrapper {
		height: 40px;
		left: 69px;
		
		top: 0;
		width: 40px;
	}

	.group-wrapper-subsection .vector-2 {
		height: 39px;
		left: 0;
		
		top: 1px;
		width: 40px;
	}

	.group-wrapper-subsection .group-6 {
		height: 200px;
		width: 24.99%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		position: relative;
	}

	.group-wrapper-subsection .group-s {
		height: 200px;
		left: 906px;
		
		top: 0;
		width: 24.99%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
	}


	.group-wrapper-subsection .overlap-4 {
		height: 47px;
		left: 0;
		
		top: 49px;
		width: 145px;
	}

	.group-wrapper-subsection .text-wrapper-23 {
		color: #000000cc;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 20px;
		font-weight: 500;
		left: 28px;
		letter-spacing: 3.20px;
		line-height: normal;
		
		top: 0;
	}

	.group-wrapper-subsection .union-wrapper {
		height: 40px;
		left: 53px;
		
		top: 0;
		width: 40px;
	}

	.group-wrapper-subsection .union {
		height: 35px;
		left: 3px;
		
		top: 3px;
		width: 33px;
	}

	.group-wrapper-subsection .group-7s {
		
		left: ‬560px;
		height: 200px;

		top: 0;
		width: 280px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
	}

	.group-wrapper-subsection .overlap-5 {
		height: 47px;
		left: 0;
		
		top: 45px;
		width: 202px;
	}

	.group-wrapper-subsection .text-wrapper-24 {
		color: #000000cc;
		font-family: "PingFang SC-Medium", Helvetica;
		font-size: 20px;
		font-weight: 500;
		left: 56px;
		letter-spacing: 3.20px;
		line-height: normal;
		
		top: 0;
	}

	.group-wrapper-subsection .union-2 {
		height: 34px;
		left: 82px;
		
		top: 0;
		width: 38px;
	}
</style>